export default __webpack_public_path__ + "static/media/rotate-screen.f1fb3be7.gif";